import apiService from './ApiService';

class AdminAsistenteService {
  async getAsistentes(options = {}) {
    const params = new URLSearchParams();
    if (options.start !== undefined && options.start !== null) params.append('start', options.start);
    if (options.end !== undefined && options.end !== null) params.append('end', options.end);
    if (typeof options.esClasico === 'boolean') params.append('esClasico', String(options.esClasico));
    const qs = params.toString();
    const response = await apiService.get(`/asistente${qs ? `?${qs}` : ''}`);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos obtener los asistentes.';
      throw new Error(msg);
    }
    const list = response?.asistentes || response?.Asistentes || response?.data || response || [];
    const items = Array.isArray(list) ? list : [];
    const total = response?.total ?? response?.Total ?? items.length;
    if (options.includeTotal || options.start !== undefined || options.end !== undefined) {
      return { items, total };
    }
    return items;
  }

  async getAsistentesClasicosColegio(options = {}) {
    const params = new URLSearchParams();
    if (options.start !== undefined && options.start !== null) params.append('start', options.start);
    if (options.end !== undefined && options.end !== null) params.append('end', options.end);
    if (options.docenteId) params.append('docenteId', options.docenteId);
    if (Array.isArray(options.docenteIds) && options.docenteIds.length > 0) {
      params.append('docenteIds', options.docenteIds.filter(Boolean).join(','));
    }
    if (options.search) params.append('search', options.search);
    const qs = params.toString();
    const response = await apiService.get(`/asistente/clasicos-colegio${qs ? `?${qs}` : ''}`);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos obtener los asistentes IA del colegio.';
      throw new Error(msg);
    }
    const items = response?.items || response?.Items || response?.asistentes || response?.Asistentes || [];
    const docentes = response?.docentes || response?.Docentes || [];
    const resumen = response?.resumen || response?.Resumen || {};
    const topDocentes = resumen?.topDocentes || resumen?.TopDocentes || response?.topDocentes || response?.TopDocentes || [];
    const total = response?.total ?? response?.Total ?? (Array.isArray(items) ? items.length : 0);
    return {
      items: Array.isArray(items) ? items : [],
      docentes: Array.isArray(docentes) ? docentes : [],
      resumen: {
        total: resumen?.total ?? resumen?.Total ?? total,
        totalPropios: resumen?.totalPropios ?? resumen?.TotalPropios ?? 0,
        totalParaAlumnos: resumen?.totalParaAlumnos ?? resumen?.TotalParaAlumnos ?? 0,
        topDocentes: Array.isArray(topDocentes) ? topDocentes : []
      },
      total
    };
  }

  async getAsistenteById(idOpenAIAssistant) {
    if (!idOpenAIAssistant) throw new Error('Falta el identificador del asistente.');
    const response = await apiService.get(`/asistente/${idOpenAIAssistant}`);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos obtener el asistente.';
      throw new Error(msg);
    }
    const data = response?.asistente || response?.Asistente;
    return data || response;
  }

  async createAsistente(payload = {}) {
    if (!payload.nombre) throw new Error('Completa el nombre del asistente.');
    if (!payload.idTipoAsistente) throw new Error('Selecciona el tipo de asistente.');
    if (!payload.idArea) throw new Error('Selecciona el área.');
    if (!payload.idColegio) throw new Error('Falta el colegio.');

    const response = await apiService.post('/asistente', payload);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos crear el asistente.';
      throw new Error(msg);
    }
    return response;
  }

  async updateAsistente(idOpenAIAssistant, payload = {}) {
    if (!idOpenAIAssistant) throw new Error('Falta el identificador del asistente.');
    if (!payload.nombre) throw new Error('Completa el nombre del asistente.');
    if (!payload.idTipoAsistente) throw new Error('Selecciona el tipo de asistente.');
    if (!payload.idArea) throw new Error('Selecciona el área.');
    if (!payload.idColegio) throw new Error('Falta el colegio.');

    const response = await apiService.put(`/asistente/${idOpenAIAssistant}`, payload);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos actualizar el asistente.';
      throw new Error(msg);
    }
    return response;
  }

  async updateAsistenteActivo(idOpenAIAssistant, activo) {
    if (!idOpenAIAssistant) throw new Error('Falta el identificador del asistente.');
    const response = await apiService.put(`/asistente/${idOpenAIAssistant}/activo`, { activo });
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos cambiar el estado del asistente.';
      throw new Error(msg);
    }
    return response;
  }

  async getReportesAsistente(idOpenAIAssistant, options = {}) {
    if (!idOpenAIAssistant) throw new Error('Falta el identificador del asistente.');

    const params = new URLSearchParams();
    if (options.filtroRol) params.append('filtroRol', options.filtroRol);
    params.append('pagina', options.pagina ?? 1);
    params.append('tamañoPagina', Math.min(options.tamañoPagina ?? 300, 300));
    params.append('limiteMensajesPorThread', Math.min(options.limiteMensajesPorThread ?? 100, 500));
    if (options.texto) params.append('texto', options.texto);
    if (options.fechaDesde) params.append('fechaDesde', options.fechaDesde);
    if (options.fechaHasta) params.append('fechaHasta', options.fechaHasta);

    const response = await apiService.get(`/asistente/${idOpenAIAssistant}/reportes?${params.toString()}`);

    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos obtener los reportes del asistente.';
      throw new Error(msg);
    }

    const threads = response.threads || response.Threads || [];
    const mensajesAplanados = [];

    threads.forEach((thread) => {
      const mensajes = thread.mensajes || thread.Mensajes || [];
      const threadId = thread.idThread || thread.IdThread || '';
      const fechaCreacionThread = thread.fechaCreacion || thread.FechaCreacion || null;
      mensajes.forEach((mensaje) => {
        mensajesAplanados.push({
          ...mensaje,
          threadId,
          fechaCreacionThread: fechaCreacionThread ? new Date(fechaCreacionThread) : null,
          fechaEnviado: mensaje.fechaEnvio ? new Date(mensaje.fechaEnvio) : null,
          fecha: mensaje.fechaEnvio ? new Date(mensaje.fechaEnvio) : null,
          mensaje: mensaje.contenido || mensaje.Contenido || '',
          usuario: mensaje.rol === 'user' || mensaje.Rol === 'user' ? 'Estudiante' : 'Asistente',
          rol: mensaje.rol || mensaje.Rol,
        });
      });
    });

    return {
      ...response,
      mensajes: mensajesAplanados,
      threads,
      totalThreads: response.totalThreads || response.TotalThreads || 0,
      totalMessages: response.totalMessages || response.TotalMessages || 0,
      paginaActual: response.paginaActual || response.PaginaActual || options.pagina || 1,
      tamañoPagina: response.tamañoPagina || response.TamañoPagina || options.tamañoPagina || 300,
      totalPaginas: response.totalPaginas || response.TotalPaginas || 1,
      totalThreadsEnBD: response.totalThreadsEnBD || response.TotalThreadsEnBD || 0,
      tienePaginaSiguiente: response.tienePaginaSiguiente || response.TienePaginaSiguiente || false,
      tienePaginaAnterior: response.tienePaginaAnterior || response.TienePaginaAnterior || false,
      total: response.totalMessages || response.TotalMessages || 0,
      informacionUtilRangoFechas: response.informacionUtilRangoFechas || response.InformacionUtilRangoFechas || '',
      informacionUtilError: response.informacionUtilError || response.InformacionUtilError || '',
      mensajesAnalizadosPorOpenAI: response.mensajesAnalizadosPorOpenAI ?? response.MensajesAnalizadosPorOpenAI ?? 0,
      ok: response.ok ?? true,
    };
  }
}

const adminAsistenteService = new AdminAsistenteService();

export default adminAsistenteService;
